export default __webpack_public_path__ + "images/0ee8bd50c7bf0f08d3b25c53586653fc-aov-unselected.svg";